import Breadcrumb from "../SharedComponents/components/Breadcrumb/Breadcrumb";
import SellerLayout from "./components/SellerLayout";
import RightArrowIconSVG from "../SharedComponents/assets/icons/svg/RightArrowIconSVG";
import MessagesInActiveRequestsTable from "./components/Tables/Table/MessagesInActiveRequestsTable";
import MessagesInOtherRequestsTable from "./components/Tables/Table/MessagesInOtherRequestsTable";

const NotificationsPage = () => {
    const breadcrumbs = [
        { title: "Početak", href: "/home" },
        { title: "Poruke" }
    ];

    return (
        <div style={styles.pageWrapper}>
            <div style={styles.breadcrumbWrapper}>
                <div style={styles.arrowIcon}>
                    <RightArrowIconSVG />
                </div>
                <Breadcrumb
                    title={"Poruke"}
                    breadcrumbs={breadcrumbs}
                />
            </div>

            <div style={styles.tableSpacing}>
                <MessagesInActiveRequestsTable />
            </div>

            <div style={styles.tableSpacing}>
                <MessagesInOtherRequestsTable />
            </div>

            <SellerLayout />
        </div>
    );
};

export default NotificationsPage;

const styles = {
    pageWrapper: {
        marginLeft: "250px",
        paddingLeft: "30px",
        paddingRight: "30px",
        paddingTop: "20px"
    },
    breadcrumbWrapper: {
        display: "flex"
    },
    arrowIcon: {
        filter: "brightness(0) saturate(100%)",
        scale: "80%",
        rotate: "180deg",
        paddingTop: "35px"
    },
    tableSpacing: {
        marginTop: 20
    }
};
